import { ComponentIds, HierarchyUtils, SelectedComponent, SnapUtils, StandardSelectionService, } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { getUprights } from "../utils/sectionsHelpers";
import { getAffectedInserts } from "./ToggleCollidersOnDrag";
import { SIZE_TO_HOST_CONNECTOR_MAP, UPRIGHT_TO_MOUNTING_RAIL, } from "../constants/connectorKeys";
import { NO_MOUNTING_RAIL, NO_UPRIGHTS } from "../constants/errors";
import { getConnectorsComponent, getHostConnectionComponent, } from "@inter-ikea-storagetwo/range/dist/functions/componentGetters";
import { CONNECTOR_DOESNT_EXISTS, NO_SNAP_ACTION, } from "@inter-ikea-storagetwo/range/dist/constants/errors";
import DisableColliderComponent from "@inter-ikea-storagetwo/range/dist/components/DisableColliderComponent";
/**
 * Resizes the selected section to desired width by snapping an upright to its
 * mounting rails corresponding host connector, based on provided size.
 *
 * @param core Core object
 * @param size Selected size to find host connector for
 * @returns Snap result or undefined if current size is selected.
 */
export const changeSelectedWidth = (core, size) => {
    var _a;
    const standardSelectionService = new StandardSelectionService(core.services.entityManager);
    const mountingRail = core.services.sceneManager.entities
        .filter((e) => e.hasComponent(ComponentIds.SELECTED_COMPONENT_ID))
        .find((e) => e.hasComponent(COMPONENT_IDS.MOUNTING_RAIL_COMPONENT));
    if (!mountingRail)
        throw new Error(NO_MOUNTING_RAIL);
    const hostKey = SIZE_TO_HOST_CONNECTOR_MAP[size];
    const isCurrentSizeSelected = getHostConnectionComponent(mountingRail).connections.find((c) => c.hostConnector.key === hostKey);
    if (isCurrentSizeSelected)
        return;
    const { rightUpright } = getUprights(mountingRail);
    if (!rightUpright)
        throw new Error(NO_UPRIGHTS);
    getAffectedInserts(rightUpright).forEach((child) => child.addComponent(new DisableColliderComponent()));
    const hostConnector = getConnectorsComponent(mountingRail).getConnectorByKey(hostKey);
    const guestConnector = getConnectorsComponent(rightUpright).getConnectorByKey(UPRIGHT_TO_MOUNTING_RAIL);
    if (!hostConnector || !guestConnector)
        throw new Error(CONNECTOR_DOESNT_EXISTS);
    const snapActionCandidate = SnapUtils.getSnap(rightUpright, guestConnector, mountingRail, hostConnector);
    if (!snapActionCandidate)
        throw new Error(NO_SNAP_ACTION);
    const snapResult = core.services.validations.validateSnapCandidate(snapActionCandidate);
    if (snapResult.valid) {
        (_a = core.modules.history()) === null || _a === void 0 ? void 0 : _a.takeSnapshot("resize section");
        snapResult.snap.performMoveAndConnect();
        const newMountingRail = HierarchyUtils.parent(rightUpright);
        standardSelectionService.setMultiSelect(true);
        newMountingRail === null || newMountingRail === void 0 ? void 0 : newMountingRail.addComponent(new SelectedComponent());
        standardSelectionService.setMultiSelect(false);
    }
    getAffectedInserts(rightUpright).forEach((child) => child.removeComponent(COMPONENT_IDS.DISABLED_COLLIDER_COMPONENT));
    return snapResult;
};
